/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ContactCreateParams,
    ContactCreateParamsFromJSON,
    ContactCreateParamsFromJSONTyped,
    ContactCreateParamsToJSON,
} from './ContactCreateParams';
import {
    FormResponse,
    FormResponseFromJSON,
    FormResponseFromJSONTyped,
    FormResponseToJSON,
} from './FormResponse';
import {
    PaymentMethod,
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
} from './PaymentMethod';
import {
    ProgramAttendeeCreateParams,
    ProgramAttendeeCreateParamsFromJSON,
    ProgramAttendeeCreateParamsFromJSONTyped,
    ProgramAttendeeCreateParamsToJSON,
} from './ProgramAttendeeCreateParams';
import {
    RegistrationStatus,
    RegistrationStatusFromJSON,
    RegistrationStatusFromJSONTyped,
    RegistrationStatusToJSON,
} from './RegistrationStatus';

/**
 * 
 * @export
 * @interface ScheduledAppointmentCreateParamsV2
 */
export interface ScheduledAppointmentCreateParamsV2 {
    /**
     * 
     * @type {string}
     * @memberof ScheduledAppointmentCreateParamsV2
     */
    appointment_type_id: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledAppointmentCreateParamsV2
     */
    appointment_option_id: string;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledAppointmentCreateParamsV2
     */
    start_time: Date;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof ScheduledAppointmentCreateParamsV2
     */
    checkout_method?: PaymentMethod;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduledAppointmentCreateParamsV2
     */
    add_credits?: boolean;
    /**
     * 
     * @type {RegistrationStatus}
     * @memberof ScheduledAppointmentCreateParamsV2
     */
    status?: RegistrationStatus;
    /**
     * 
     * @type {string}
     * @memberof ScheduledAppointmentCreateParamsV2
     */
    contact_id?: string;
    /**
     * 
     * @type {ContactCreateParams}
     * @memberof ScheduledAppointmentCreateParamsV2
     */
    new_contact?: ContactCreateParams;
    /**
     * 
     * @type {string}
     * @memberof ScheduledAppointmentCreateParamsV2
     */
    program_attendee_id?: string;
    /**
     * 
     * @type {ProgramAttendeeCreateParams}
     * @memberof ScheduledAppointmentCreateParamsV2
     */
    new_attendee?: ProgramAttendeeCreateParams;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduledAppointmentCreateParamsV2
     */
    send_email?: boolean;
    /**
     * 
     * @type {FormResponse}
     * @memberof ScheduledAppointmentCreateParamsV2
     */
    form_response?: FormResponse;
}

export function ScheduledAppointmentCreateParamsV2FromJSON(json: any): ScheduledAppointmentCreateParamsV2 {
    return ScheduledAppointmentCreateParamsV2FromJSONTyped(json, false);
}

export function ScheduledAppointmentCreateParamsV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledAppointmentCreateParamsV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'appointment_type_id': json['appointment_type_id'],
        'appointment_option_id': json['appointment_option_id'],
        'start_time': (new Date(json['start_time'])),
        'checkout_method': !exists(json, 'checkout_method') ? undefined : PaymentMethodFromJSON(json['checkout_method']),
        'add_credits': !exists(json, 'add_credits') ? undefined : json['add_credits'],
        'status': !exists(json, 'status') ? undefined : RegistrationStatusFromJSON(json['status']),
        'contact_id': !exists(json, 'contact_id') ? undefined : json['contact_id'],
        'new_contact': !exists(json, 'new_contact') ? undefined : ContactCreateParamsFromJSON(json['new_contact']),
        'program_attendee_id': !exists(json, 'program_attendee_id') ? undefined : json['program_attendee_id'],
        'new_attendee': !exists(json, 'new_attendee') ? undefined : ProgramAttendeeCreateParamsFromJSON(json['new_attendee']),
        'send_email': !exists(json, 'send_email') ? undefined : json['send_email'],
        'form_response': !exists(json, 'form_response') ? undefined : FormResponseFromJSON(json['form_response']),
    };
}

export function ScheduledAppointmentCreateParamsV2ToJSON(value?: ScheduledAppointmentCreateParamsV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'appointment_type_id': value.appointment_type_id,
        'appointment_option_id': value.appointment_option_id,
        'start_time': (value.start_time.toISOString()),
        'checkout_method': PaymentMethodToJSON(value.checkout_method),
        'add_credits': value.add_credits,
        'status': RegistrationStatusToJSON(value.status),
        'contact_id': value.contact_id,
        'new_contact': ContactCreateParamsToJSON(value.new_contact),
        'program_attendee_id': value.program_attendee_id,
        'new_attendee': ProgramAttendeeCreateParamsToJSON(value.new_attendee),
        'send_email': value.send_email,
        'form_response': FormResponseToJSON(value.form_response),
    };
}

